const RouteLoadingFallback = () => (
  <div
    role="status"
    aria-live="polite"
    aria-label="Loading page"
    style={{
      minHeight: '50vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <div
      style={{
        width: 32,
        height: 32,
        border: '3px solid rgba(26, 35, 126, 0.2)',
        borderTopColor: '#1a237e',
        borderRadius: '50%',
        animation: 'rlf-spin 0.8s linear infinite',
      }}
    />
    <style>{`@keyframes rlf-spin { to { transform: rotate(360deg); } }`}</style>
  </div>
);

export default RouteLoadingFallback;